import { render, staticRenderFns } from "./GiftPackage.vue?vue&type=template&id=ba36f214"
import script from "./GiftPackage.vue?vue&type=script&lang=js"
export * from "./GiftPackage.vue?vue&type=script&lang=js"
import style0 from "./GiftPackage.vue?vue&type=style&index=0&id=ba36f214&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports